import { render, staticRenderFns } from "./RecruiterFeeForm.vue?vue&type=template&id=1ff320d3&scoped=true&"
import script from "./RecruiterFeeForm.vue?vue&type=script&lang=js&"
export * from "./RecruiterFeeForm.vue?vue&type=script&lang=js&"
import style0 from "./RecruiterFeeForm.vue?vue&type=style&index=0&id=1ff320d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff320d3",
  null
  
)

export default component.exports